// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

interface IDashobard {
  studentId: string;
  niveau: string;
  matiere: string;
}

// Define a service using a base URL and expected endpoints
export const studentDashboardApi = createApi({
  reducerPath: "studentDashboardApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),
  tagTypes: ["ADS"],
  endpoints: (builder) => ({
    dashboard: builder.mutation<any, IDashobard>({
      query: (body) => {
        return {
          url: `/quizz/student/dashboard`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ADS"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useDashboardMutation } = studentDashboardApi;
